<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("committee.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  class="primary"
                  @click="
                    addCommitteeDialog = true;
                    committee = {};
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Committee Member
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="committeemembers"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.profile_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.profile_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.profile_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">{{
                    item.name ? item.name.charAt(0) : ""
                  }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.house_number="{ item }">
                <span v-if="item.flat_name">{{ item.flat_name }}-</span>
                <span>{{ item.house_number }}</span>

                <!-- {{ item.house_number }} {{item.flat.name}} -->
              </template>

              <template v-slot:item.business="{ item }">
                {{ item.business ? item.business : 'N/A' }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="secondary"
                  icon
                  style="margin-left: -10px"
                  @click="
                    addCommitteeDialog = true;
                    getMemberDetail(
                      item.id,
                      item.member_id,
                      item.role,
                      item.flat_id
                    );
                  "
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_committee"
                  title="Delete Committee"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog
        v-model="addCommitteeDialog"
        max-width="450"
        @click:outside="closeDialog"
      >
        <v-card>
          <v-card-title class="text-h5">
            {{ committee.id ? "Edit" : "Add" }} Committee Member
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="selected_type" row>
                  <v-radio
                    v-for="type in types"
                    :key="type.field"
                    :label="type.label"
                    :value="type.field"
                    @change="committee.flat_id='null';committee.member_id='';getFlatMember();"
                  ></v-radio>
                </v-radio-group>
           
                <v-autocomplete v-if="selected_type == 'flat'"
                  v-model="committee.flat_id"
                  title="flat"
                  name="flat"
                  label="Block"
                  :items="flats"
                  item-text="name"
                  item-value="id"
                  data-vv-as="Block"
                  clearable
                  @change="getFlatMember()"
                  v-validate="'required'"
                  :error="
                    errors.first('flat') != null ||
                    serverSideErrors.flat_id != null
                  "
                  :error-messages="
                    errors.first('flat') || serverSideErrors.flat_id
                  "
                >
                </v-autocomplete>
            
                <v-autocomplete
                  v-model="committee.member_id"
                  title="member_id"
                  name="member_id"
                  label="Member"
                  :items="members"
                  item-text="name"
                  item-value="id"
                  v-validate="'required'"
                  data-vv-as="Member"
                  clearable
                  :error="
                    errors.first('member_id') != null ||
                    serverSideErrors.member_id != null
                  "
                  :error-messages="
                    errors.first('member_id') || serverSideErrors.member_id
                  "
                >
                </v-autocomplete>
                <v-text-field
                  v-model="committee.role"
                  name="role"
                  id="role"
                  label="Designation"
                  v-validate="'required'"
                  data-vv-as="Designation"
                  :error="
                    errors.first('role') != null ||
                    serverSideErrors.role != null
                  "
                  :error-messages="
                    errors.first('role') || serverSideErrors.role
                  "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateCommitteeMember(committee.id)"
              v-if="committee.id"
            >
              Update
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="saveCommitteeMember"
              v-else
            >
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="deleteCommitteemember(delete_id)"
            >
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("committee.headers.profile")}`,
          value: "profile_url",
          sortable: false,
        },
        {
          text: `${this.$t("committee.headers.house_no")}`,
          value: "house_number",
        },
        {
          text: `${this.$t("committee.headers.member")}`,
          value: "name",
        },
        {
          text: `${this.$t("committee.headers.contact_no")}`,
          value: "mobile_no",
        },
        {
          text: `${this.$t("committee.headers.designation")}`,
          value: "role",
        },
        {
          text: `${this.$t("committee.headers.business")}`,
          value: "business",
        },
        {
          text: `${this.$t("committee.headers.actions")}`,
          value: "actions",
          sortable: false,
        },
      ],
      types: [
        {
          label: "Block",
          field: "flat",
        },
        {
          label: "Single house",
          field: "single_house",
        },
      ],
      user: {},
      addCommitteeDialog: false,
      deleteDialog: false,
      members: [],
      committeemembers: [],
      serverSideErrors: [],
      delete_id: "",
      selected_type: "flat",
      flats: [],
      committee: {
        member_id: "",
        flat_id: "",
        role: "",
      },
      options: {
        sortBy: ["created_at"]
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler () {
        this.getCommitteeMembers();
      },
      deep: true,
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getCommitteeMembers() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios.get("societyadmin/committeeMembers"+
          "?page=" + page +
          "&perPage=" + itemsPerPage +
          "&sortBy=" + sortBy +
          "&sortDesc=" + sortDesc +
          "&search=" + search
      )
      .then((response) => {
        _self.loading = false;
        
        let data = response.data;
        if (data.status) {
          _self.committeemembers = data.committeeMembers;
          _self.totalRecords = data.total;
          _self.page = data.page > data.lastPage ? 1 : data.page;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
          if (data.type == "invalid") {
            localStorage.removeItem("user");
            _self.$router.push({ path: "/societyadmin/login" });
          }
        }
      });
    },
    getFlat() {
      let _self = this;
      _self.$axios.get("societyadmin/flats").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.flats = data.flats;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getMembers() {
      let _self = this;
      _self.$axios
        .get("societyadmin/members?society_id=" + _self.user.id)

        .then((response) => {
          let data = response.data;
          console.log(data);
          if (data.status) {
            _self.members = data.members;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFlatMember() {
      let _self = this;
      this.members;
      this.$axios
        .get("/societyadmin/flats/" + this.committee.flat_id + "/members")
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.members = data.members;
            // this.flat_member = data.members;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    deleteCommitteemember(memberId) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/committeeMembers/" + memberId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.confirmDelete();
            this.getCommitteeMembers();
            this.closeDialog();
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    saveCommitteeMember() {
      let _self = this;
      this.$validator.validateAll().then((success) => {
        if (success) {
          console.log(_self.committee);
          this.$axios
            .post("/societyadmin/committeeMembers", _self.committee)
            .then((response) => {
              let data = response.data;
              if (data.status) {
                // add module to the array
                // this.committeemembers.push(data.committee);
                this.getCommitteeMembers();
                this.closeDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};
                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
        }
        // submit the value
      });
    },
    updateCommitteeMember(id) {
      let _self = this;
      this.$validator.validateAll().then((success) => {
        if (success) {
          _self.committee.society_id = _self.user.id;
          this.$axios
            .put("/societyadmin/committeeMembers/" + id, _self.committee)
            .then((response) => {
              let data = response.data;
              if (data.status) {
                // add module to the array
                // this.committeemembers.push(data.committee);
                this.getCommitteeMembers();
                this.closeDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};
                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
        }
        // submit the value
      });
    },
    getMemberDetail(id, member_id, role, flat_id) {
      this.committee.id = id;
      this.committee.member_id = member_id;
      this.committee.role = role;
      this.committee.flat_id = flat_id;
      if (flat_id == null) {
        this.selected_type = "single_house";
      } else {
         this.selected_type = "flat";
      }
      this.getFlatMember();
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("committemember_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("committemember_search", trimmedSearch);
      }
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addCommitteeDialog = false;
      this.committee = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    debounceInput: debounce(function(){
      this.getCommitteeMembers();
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};

    // this.getMembers();
    this.getFlat();
    this.committee.flat_id = '';
    // this.getFlatMember();
    // this.getCommitteeMembers();
   
    this.search = sessionStorage.getItem("committemember_search");
  },
};
</script>